/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { api } from "api";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import EmployeeLeaving from "./EmployeeLeaving";
import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";

class EmployeeLeavings extends Component {
  state = {
    filteredData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
    sort_by: "trFullname",
    sort_dir: "desc",
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.setState({ filteredData: this.props.employees });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.employees !== this.props.employees) {
      this.setState({ filteredData: this.props.employees });
    }

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredData: this.props.employees.filter((item) => {
          return (
            Helpers.getTurkishCharaterFixedList(item.fullname).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(item.position.name).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(item.company.name).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(item.personalEmail).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(
              item.personalCellphone
            ).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(item.city).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            )
          );
        }),
        activePage: 1,
      });
    }
  }

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value, activePage: 1 });
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderHeaderToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredData?.length > 0
              ? this.state.filteredData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  handleExport = () => {
    this.props.onProcessBegin();
    api
      .get("/api/applicant-pool/export-approved-applicant-pool")
      .then((response) => {
        const fileName = response.headers["content-disposition"]
          .split(";")[1]
          .split("=")[1];
        this.downloadFile(response, fileName);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  downloadFile = (res, fname) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fname);
    document.body.appendChild(link);
    link.click();
  };

  renderFooterToolbar = () => {
    return (
      <div className="table-footer-toolbar mt-4 mb-4">
        <button className="export-button" onClick={this.handleExport}>
          <Trans desc="Dışa Aktar">10113</Trans>
        </button>
      </div>
    );
  };

  trFullname = "";
  trCompany = "";
  trCity = "";
  trPosition = "";
  trQualifications = "";
  trWorkleft = "";
  trPersonalCellphone = "";
  trPersonalEmail = "";
  trReference = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trFullname = "";
    this.trCompany = "";
    this.trCity = "";
    this.trPosition = "";
    this.trQualifications = "";
    this.trWorkleft = "";
    this.trPersonalEmail = "";
    this.trPersonalCellphone = "";
    this.trReference = "";

    switch (this.state.sort_by) {
      case "trFullname":
        this.trFullname = `_${this.state.sort_dir}`;
        break;
      case "trCompany":
        this.trCompany = `_${this.state.sort_dir}`;
        break;
      case "trCity":
        this.trCity = `_${this.state.sort_dir}`;
        break;
      case "trPosition":
        this.trPosition = `_${this.state.sort_dir}`;
        break;
      case "trQualifications":
        this.trQualifications = `_${this.state.sort_dir}`;
        break;
      case "trWorkleft":
        this.trWorkleft = `_${this.state.sort_dir}`;
        break;
      case "trPersonalEmail":
        this.trPersonalEmail = `_${this.state.sort_dir}`;
        break;
      case "trPersonalCellphone":
        this.trPersonalCellphone = `_${this.state.sort_dir}`;
        break;
      case "trReference":
        this.trReference = `_${this.state.sort_dir}`;
        break;
      default:
        this.trFullname = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trFullname":
          return this.state.sort_dir === "desc"
            ? a.fullname.localeCompare(b.fullname)
            : b.fullname.localeCompare(a.fullname);
        case "trCompany":
          return this.state.sort_dir === "desc"
            ? a.company?.name.localeCompare(b.company?.name)
            : b.company?.name.localeCompare(a.company?.name);
        case "trCity":
          return this.state.sort_dir === "desc"
            ? (a.city ?? "").localeCompare(b.city ?? "")
            : (b.city ?? "").localeCompare(a.city ?? "");
        case "trPosition":
          return this.state.sort_dir === "desc"
            ? a.position?.name.localeCompare(b.position?.name)
            : b.position?.name.localeCompare(a.position?.name);
        case "trQualifications":
          return this.state.sort_dir === "desc"
            ? (a.qualifications ?? 0) - (b.qualifications ?? 0)
            : (b.qualifications ?? 0) - (a.qualifications ?? 0);
        case "trWorkleft":
          return this.state.sort_dir === "desc"
            ? new Date(a.workleft) - new Date(b.workleft)
            : new Date(b.workleft) - new Date(a.workleft);
        case "trPersonalEmail":
          return this.state.sort_dir === "desc"
            ? (a.personalEmail ?? "").localeCompare(b.personalEmail ?? "")
            : (b.personalEmail ?? "").localeCompare(a.personalEmail ?? "");
        case "trPersonalCellphone":
          return this.state.sort_dir === "desc"
            ? (a.personalCellphone ?? "").localeCompare(
              b.personalCellphone ?? ""
            )
            : (b.personalCellphone ?? "").localeCompare(
              a.personalCellphone ?? ""
            );
        case "trReference":
          return this.state.sort_dir === "desc"
            ? a.reference?.label.localeCompare(b.reference?.label)
            : b.reference?.label.localeCompare(a.reference?.label);
        default:
          return this.state.sort_dir === "desc"
            ? a.fullname.localeCompare(b.fullname)
            : b.fullname.localeCompare(a.fullname);
      }
    });

    return sorted.slice(start, end).map((employee) => {
      return <EmployeeLeaving key={employee.id} employee={employee} />;
    });
  };

  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();

    return (
      <>
        {this.props.spinner}
        <div>{this.renderHeaderToolbar()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="ayrilanCalisan"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive dataTable no-footer dtr-none collapsed"
            id="dataTablePersonal"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trFullname")}
                  className={`all sorting${this.trFullname}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Ad Soyad">10601</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trCompany")}
                  className={`all sorting${this.trCompany}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Rol">10602</Trans>
                  </div>
                </th>
                <DesktopBreakpoint>
                  <th
                    onClick={() => this.reOrder("trCity")}
                    className={`desktop sorting${this.trCity}`}
                  >
                    <div className="tableTitle">
                      <Trans>applicantpool_city</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trPosition")}
                    className={`desktop sorting${this.trPosition}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Pozisyon">10603</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trQualifications")}
                    className={`desktop sorting${this.trQualifications}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="ETO">10701</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trWorkleft")}
                    className={`desktop sorting${this.trWorkleft}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="İşten Ayrılma">10605</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trPersonalEmail")}
                    className={`desktop sorting${this.trPersonalEmail}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="E-posta">10606</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trPersonalCellphone")}
                    className={`desktop sorting${this.trPersonalCellphone}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Cep Telefonu">10607</Trans>
                    </div>
                  </th>
                  <th className={`desktop`}>
                    <div className="tableTitle">
                      <Trans>applicantpool_workcity</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trReference")}
                    className={`desktop sorting${this.trReference}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Referans">10703</Trans>
                    </div>
                  </th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
        <div>
          <hr />
          {this.renderFooterToolbar()}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {}
)(containsLongRunningProcess(requireAuth(EmployeeLeavings)));
